function bankCard(
  state = {
    public_token: "",
    metadata: {},
    // options: {
    //   refresh: null,
    //   updateLogin: null,
    //   unlinkInstitution: null,
    //
    // }
    attempts: 0
  },
  action
) {
  switch (action.type) {
    case "RESET_PLAID_ATTEMPTS":
      return {
        ...state,
        attempts: 0
      }
    case "PLAID_ERROR":
      return {
        ...state,
        attempts: state.attempts + 1
      }
    case "REFRESH_INSTITUTIONS_REQUEST":
      return {
        ...state,
        isRefreshing: true
      }
    case "REFRESH_INSTITUTIONS_SUCCESS":
      return {
        ...state,
        isRefreshing: false
      }

    case "SET_PLAID_LINK_DATA":
      const { metadata, public_token } = action
      return {
        ...state,
        metadata,
        public_token
      }

    case "SET_PLAID_IMPORT_HISTORY":
      const { import_history } = action
      return {
        ...state,
        import_history
      }

    // case "BANK_ADDED":
    // case "CARD_ADDED":
    default:
      return state
  }
}
export default bankCard



// WEBPACK FOOTER //
// ./src/account/bank-card/reducer.js